package com.narbase.bos.common

/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] -[2019] Narbase Technologies
 * All Rights Reserved.
 * Created by islam
 * On: 2022/01/31.
 */
object Constants {
    const val MEDICO_TRIAL_LINK = "/book_demo"
    const val GETTING_STARTED_LINK = Constants.MEDICO_TRIAL_LINK
}